export enum BtnType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  TRANSPARENT = 'transparent',
}

export enum BtnSize {
  SMALL = 'small',
  LARGE = 'large',
}

export interface PropsIcon {
  left?: {
    name: string
    colorFill: string
    size: string
  }
  right?: {
    name: string
    colorFill: string
    size: string
  }
}

export interface PropsBtn {
  icons?: PropsIcon
  isDisabled?: boolean
  isNewTab?: boolean
  size: BtnSize
  text: string
  type?: BtnType
  url?: string
}
